import * as THREE from "three";

export const MAXX_SEMANTIC_STAGES = [
  {
    id: "maxx_synapse_connection",
    end: 0.14,
    label: "Synapse Formation",
    meaning: "Two neurons connect and form their synapse.",
  },
  {
    id: "maxx_signal_transfer",
    end: 0.32,
    label: "Signal Transfer",
    meaning: "Transmitters send signals between the neurons.",
  },
  {
    id: "maxx_new_experience",
    end: 0.45,
    label: "New Experience",
    meaning: "New experience is created through the signal exchange.",
  },
  {
    id: "maxx_connection_quality",
    end: 0.58,
    label: "Connection Quality",
    meaning: "The quality of experience is shaped by neural connections.",
  },
  {
    id: "maxx_new_pathways",
    end: 0.72,
    label: "New Pathways",
    meaning: "Connections scale and establish new neural pathways.",
  },
  {
    id: "maxx_neuroplasticity_metaphor",
    end: 1,
    label: "Neuroplasticity and Neurogenesis",
    meaning: "The sequence resolves into transformation through neuroplasticity and neurogenesis as a visual metaphor.",
  },
];

const MAXX_STAGE_BY_ID = new Map(MAXX_SEMANTIC_STAGES.map((stage) => [stage.id, stage]));

export function inferMaxxSemanticStageFromProgress(progress) {
  const normalized = Number.isFinite(progress)
    ? THREE.MathUtils.clamp(progress, 0, 1)
    : 0;

  return MAXX_SEMANTIC_STAGES.find((stage) => normalized < stage.end)?.id ||
    "maxx_neuroplasticity_metaphor";
}

export function semanticStageForMaxxPhase(phase) {
  const normalized = String(phase || "").toLowerCase();
  return {
    brain_entry: "maxx_synapse_connection",
    signal_flow: "maxx_signal_transfer",
    new_pathways: "maxx_new_pathways",
    memory_building: "maxx_neuroplasticity_metaphor",
    inside_the_brain: "maxx_neuroplasticity_metaphor",
  }[normalized] || null;
}

export function getMaxxSemanticStage(stageId) {
  return MAXX_STAGE_BY_ID.get(String(stageId || "").toLowerCase()) || null;
}

export function inferMaxxPhaseFromProgress(progress) {
  const normalized = Number.isFinite(progress)
    ? THREE.MathUtils.clamp(progress, 0, 1)
    : 0;

  if (normalized < 0.14) return "brain_entry";
  if (normalized < 0.45) return "signal_flow";
  if (normalized < 0.72) return "new_pathways";
  return "memory_building";
}
